import React, { Component } from 'react'
import { withRouter, RouteComponentProps } from 'react-router'

import { GenericButton } from '../../'

import PerformanceOverview from './PerformanceOverview'
import RecentSales from './RecentSales'
import Alerts from './Alerts'

import history from '../../../browserHistory'

import { PerformanceStore } from '../../../typings/stores/PerformanceStore'
import { RecentSalesStore } from '../../../typings/stores/RecentSalesStore'
import { AlertsStore } from '../../../typings/stores/AlertsStore'
import { DateRange } from '../../../typings/dates'

import styles from './styles.module.css'

interface DashboardProps extends RouteComponentProps {
  handleFilterChange(): void
  performance?: PerformanceStore
  recentSales?: RecentSalesStore
  alerts?: AlertsStore
  selectedDateRange?: DateRange
}

class Dashboard extends Component<DashboardProps> {
  viewReports = () => {
    history.push('/app/reports')
  }

  render() {
    const {
      handleFilterChange,
      performance,
      recentSales,
      selectedDateRange,
      alerts,
    } = this.props

    return (
      <div className={styles.container} data-rv="dash-container">
        <h1 className="screen-reader-text">Dashboard</h1>
        <PerformanceOverview
          handleFilterChange={handleFilterChange}
          performance={performance}
          selectedDateRange={selectedDateRange}
        />
        <div className={styles.buttonPanel}>
          <GenericButton
            onClick={() => this.viewReports()}
            data-rv="view-reports-btn"
          >
            View Reports
          </GenericButton>
        </div>
        <div className={styles.splitColumn}>
          <RecentSales recentSales={recentSales} data-rv="rr-container" />
          <Alerts
            className={styles.dashboard}
            alerts={alerts}
            data-rv="alerts-container"
          />
        </div>
      </div>
    )
  }
}

export default withRouter(Dashboard)
